import { useEffect, useState } from 'react'

import { useGetStoresQuery } from '@/screens/Product/api/productApiSlice'

import { Shop } from '@/features/product/choose-pickup-point/types/shop'

import { useGetDiscountProductStoresQuery } from '@/entities/catalog-discount'

import { SegmentedControl } from '@/shared/ui/segmented-control'

import { usePickup } from '../../hooks/usePickup'
import { ShopsList } from '../ShopsList/ShopsList'
import { ShopsMap } from '../ShopsMap/ShopsMap'

import cl from './Pickup.module.scss'

type ShopsView = 'map' | 'list'

const pickupViewOptions = [
	{ label: 'Карта', value: 'map' },
	{ label: 'Список', value: 'list' }
]

interface PickupProps {
	className?: string
	shops?: Shop[]
	inProduct?: boolean
	isShops?: boolean
	productId?: number
	discountProductId?: number | string
}

export const Pickup = (props: PickupProps) => {
	const { className, inProduct, productId, discountProductId, shops: providedShops } = props
	const isDiscountPickup = discountProductId != null

	const { data: regularStoresResponse } = useGetStoresQuery(Number(productId), {
		skip: isDiscountPickup || !productId
	})
	const { data: discountStores = [] } = useGetDiscountProductStoresQuery(String(discountProductId ?? ``), {
		skip: !isDiscountPickup
	})

	const shops = isDiscountPickup ? discountStores : regularStoresResponse?.data || providedShops

	const { selectedShop, handleShopSelection, resetSelection } = usePickup({
		onSubmition: () => {},
		shops
	})

	const [selectedView, setSelectedView] = useState<ShopsView>('map')

	const showList = selectedView === 'list'
	const showMap = selectedView === 'map'

	const handleViewChange = (value: ShopsView) => {
		setSelectedView(value)
	}

	// Сбрасываем активный магазин при размонтировании компонента
	useEffect(() => {
		return () => {
			resetSelection() // Сбрасываем выбранный магазин
		}
	}, [])

	return (
		<div className={className}>
			<div className={cl.header}>
				<SegmentedControl
					className={cl.tabs}
					size="sm"
					options={pickupViewOptions}
					value={selectedView}
					onChange={value => handleViewChange(value as ShopsView)}
				/>
			</div>

			{showList && (
				<ShopsList
					shops={shops}
					activeValue={selectedShop?.name}
					onSelect={handleShopSelection}
					hideRadio={inProduct}
					isDiscountPickup={isDiscountPickup}
				/>
			)}

			{showMap && (
				<section className={cl.mapBody}>
					<div className={cl.map} datatype="map">
						<ShopsMap
							shops={shops}
							activeShopID={selectedShop?.storeId}
							onSelect={handleShopSelection}
							isDiscountPickup={isDiscountPickup}
						/>
					</div>
				</section>
			)}
		</div>
	)
}
